import { useCallback, useContext, useEffect, useState } from 'react';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../../../shared/components';

import { StepTwoFormContext } from '../../../../contexts/StepTwoForm';

import { ValidateForm } from '../../../../../../../../../../../shared/utils';
import { MasterContext } from '../../../../../../../../../../../shared/contexts';
import { QuotationInfoContext } from '../../../../../../../shared';
import { getExplanatoryTexts } from '../../../../../../../utils';
import { Typography } from 'antd';
import { COLORS } from '../../../../../../../../../../../config/themes/colors';

interface PlansSectionProps {
  duplicateId?: number;
  id: number;
}

export const PlansSection = ({ duplicateId, id }: PlansSectionProps) => {
  const validateForm = new ValidateForm();

  const { stepTwoForm, planOptionsBySelectedPlan } =
    useContext(StepTwoFormContext);

  const handleDuplicateFields = () => {
    if (duplicateId) {
      const allFieldsValues = stepTwoForm?.getFieldsValue(true);

      const duplicatedFieldsValues = Object.keys(allFieldsValues).reduce(
        (acc, key) => {
          if (key.includes(`-tab-${duplicateId}`)) {
            const newKey = key.replace(`-tab-${duplicateId}`, `-tab-${id}`);
            acc[newKey] = allFieldsValues[key];
          }

          return acc;
        },
        {} as Record<string, any>
      );

      stepTwoForm?.setFieldsValue(duplicatedFieldsValues);
    }
  };

  const { globalPublicConfigs } = useContext(MasterContext);
  const { quotationInfo } = useContext(QuotationInfoContext);
  const [explanatoryText, setExplanatoryText] = useState<string>("");   

  const handleExplanatoryText = useCallback(() => {
    const text = getExplanatoryTexts(
      Number(quotationInfo?.branch),
      Number(quotationInfo?.article), 
      Number(stepTwoForm?.getFieldValue(`plan-tab-${id}`)),
      globalPublicConfigs?.QUOTATION_EXPLANATORY_TEXTS
    );
    setExplanatoryText(text);
    stepTwoForm?.setFieldValue(`explanatory-text-tab-${id}`, text);
  }, [quotationInfo?.branch, quotationInfo?.article, globalPublicConfigs?.QUOTATION_EXPLANATORY_TEXTS, stepTwoForm, id]);

  useEffect(() => {
    handleDuplicateFields();
    handleExplanatoryText();
  }, [handleExplanatoryText]);

  return (
    <ContentSection level='h3' title='Planes'>
      <RowSize>
        <ColSize size={25}>
          <SelectForm
            formProps={{
              hasFeedback: true,
              label: 'Lista de Planes:',
              name: `plan-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'lista de planes',
                rules: ['required'],
              }),
            }}
            selectProps={{ 
              options: planOptionsBySelectedPlan,
              onChange: handleExplanatoryText,
             }}
          />
        </ColSize>
      </RowSize>
      {!!explanatoryText && 
      <Typography.Text strong style={{ fontSize: 16, color: COLORS.neutrals[70] }} >
        {explanatoryText}
      </Typography.Text>
      }         
    </ContentSection>
  );
};
